import React from 'react';

import makeDeprecatedJadeStyleTemplate from 'util/makeDeprecatedJadeStyleTemplate';

export interface OwnableChoiceProps {
  owner_handle: string;
  writable: boolean;
  name: string;
}

// eslint-disable-next-line camelcase
function OwnableChoice({owner_handle, writable, name}: OwnableChoiceProps): JSX.Element {
  return (
    <span>
      <span className="ownable-owner">
        {
          // eslint-disable-next-line camelcase
          owner_handle
        }
        {!writable && <span className="glyphicon glyphicon-eye-open" />}
      </span>{' '}
      {name}
    </span>
  );
}

export default makeDeprecatedJadeStyleTemplate<OwnableChoiceProps>(OwnableChoice);
